/** Format a value in cents as a dollar string (e.g., 2500 → "25.00") */
export const formatCentsAsDollars = (cents: number): string => (cents / 100).toFixed(2);
